import * as React from "react";
import { Dropdown } from "semantic-ui-react";

import { connect } from "react-redux";
import { Dispatch } from "redux";

import { push } from "redux-little-router";

interface DispatchProps {
    push: (path: string) => void;
}

interface OwnProps {
    href: string;
}

type Props = OwnProps & DispatchProps & JSX.ElementChildrenAttribute;

class DropdownItemLinkUnconnected extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        this.pushHref = this.pushHref.bind(this);
    }

    public render() {
        return (
            <Dropdown.Item onClick={this.pushHref} >
                <a href={this.props.href}>{this.props.children}</a>
            </Dropdown.Item>
        );
    }

    private pushHref(event: React.MouseEvent<HTMLDivElement>) {
        event.preventDefault();
        this.props.push(this.props.href);
    }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        push: (path: string) => dispatch(push(path))
    };
}

export const DropdownItemLink = connect(null, mapDispatchToProps)(DropdownItemLinkUnconnected);
